import React, { useEffect } from "react";
import AdminIcon from "../../assets/icons/user-access-icons/admin-icon";
import RecruitingManagerIcon from "../../assets/icons/user-access-icons/recruiting-manager-icon";
import RecruiterIcon from "../../assets/icons/user-access-icons/recruiter-icon";
import UserIcon from "../../assets/icons/user-access-icons/user-icon";
import { Link } from "react-router";
import DefaultPermissionsButton from "./default-permission-button";
import useMediaQuery from "../common/custom-hooks/use-media-query";
import AllowedAccess from "../../guards/AllowedAccess";
import PermissionList from "../../guards/PermissionList";

const TotalCountCard = ({
  title = "Total Clinics",
  count = "0",
  bgColor = "bg-blue-50",
  borderColor = "border-blue-100",
  textColor = "text-[#373737]",
  icondivBgColor = "bg-[#D1D6FF]",
  iconColor = "text-blue-600",
  iconBgColor = "bg-[#546DFE]",
  loading,
  isSlideOpen,
  openPermissionDrawer,
  key
}) => {
  function formatCount(count) {
    return count < 10 ? `0${count}` : `${count}`;
  }
  const isLaptopScreen = useMediaQuery("(max-width: 1521px)");
  useEffect(() => {
    console.log("isLaptopScreen", isLaptopScreen);
  }, [isLaptopScreen]);

  return (
    <div className={`p-[2px] rounded-lg border ${borderColor} font-mont`}>
      <div
        className={`flex items-center justify-between p-4 ${bgColor} rounded-lg shadow-sm`}
      >
        {/* Text Section */}
        <div>
          <p className="font-mont font-[400] text-[16px] text-[#1B2A3D]">
            {count} Accounts
          </p>
          <h1
            className={`text-3xl font-[500] ${textColor} text-[20px] mt-[10px]`}
          >
            {loading?<div className="mini-spinner mt-3"></div>:title}
          </h1>
          <AllowedAccess permissions={[PermissionList.admin_userAccess.view_permissions]}>
            <DefaultPermissionsButton isSlideOpen={isSlideOpen} onClick={openPermissionDrawer} />
          </AllowedAccess>
          
        </div>
        {/* Icon Section */}
        {!isSlideOpen && (
          <div
            className={`flex items-center justify-center w-12 h-12 ${icondivBgColor} rounded-lg`}
          >
            <div className={` ${iconBgColor} p-1 rounded-lg`}>
              {(() => {
                switch (title) {
                  case "Admin":
                    return <AdminIcon />;
                  case "Recruiting Manager":
                    return <RecruitingManagerIcon />;
                  case "Recruiter":
                    return <RecruiterIcon />;
                  case "User":
                    return <UserIcon />;
                  default:
                    return <UserIcon />;
                }
              })()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalCountCard;
